import { render, staticRenderFns } from "./Frame1920.vue?vue&type=template&id=d35d5504&scoped=true"
import script from "./Frame1920.vue?vue&type=script&lang=js"
export * from "./Frame1920.vue?vue&type=script&lang=js"
import style0 from "./Frame1920.vue?vue&type=style&index=0&id=d35d5504&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35d5504",
  null
  
)

export default component.exports